$shm_tests_player $mol_view
	result null
	comparison_results /
	manifest_uri \
	speed? 1
	play_step_index? -1
	segment_index? 0
	current_step_index -1
	current_visual* null
	current_title \
	current_step_range \
	sub /
		<= Workspace $mol_view
			sub /
				<= Main $mol_view
					sub <= workspace_rows /$mol_view
	Video $mol_video_player
		uri <= video_uri \
		playing? => playing?
		time? => time?
		duration => media_duration 0
		controls true
		autoplay <= video_autoplay false
		muted true
		inline true
		loop <= video_loop false
		event *
			^
			timeupdate? <=> step_timeupdate? null
			ended? <=> video_ended? null
	Current $mol_view
		sub /
			<= Current_benchmarks $mol_view
				sub <= current_benchmark_content /$mol_view
			<= Current_media $mol_view
				sub <= current_media_rows /$mol_view
	Controls $mol_view
		sub /
			<= Play_step $mol_check_icon
				checked? <=> play_step_active? false
				title \
				hint <= play_step_title \
				enabled <= play_step_enabled false
				click? <=> play_step? null
				Icon <= Play_step_icon $mol_icon_loop
			<= Play $mol_button_minor
				title <= play_title \
				click? <=> play_toggle? null
			<= Speed $mol_button_minor
				title <= speed_title \
				click? <=> speed_cycle? null
			<= Time $mol_view
				sub / <= time_title \
	Current_benchmark_table $shm_tests_benchmark_table
		results <= comparison_results
		step_title <= current_step_title \
		step_index <= current_step_index
	Current_visual* $shm_tests_visual
		comparison <= current_visual*
		manifest_uri <= manifest_uri
	Current_screenshot* $mol_image
		uri <= current_screenshot_uri* \
		title <= current_screenshot_title* \
	Current_screenshot_empty $mol_paragraph
		title \У текущего шага нет контрольного скриншота.
